import React from "react";
import useFetch from "@/lib/useFetch";
import { GlassCard, PageTitle, LuxuryButton, EmptyState } from "@/components/lux";
import api, { money } from "@/lib/api";
import { BscScanLink, statusMeta } from "@/components/DepositStatus";
import { toast } from "sonner";
import { Wallet } from "lucide-react";

export default function AdminDeposits() {
  const { data, loading, reload } = useFetch("/admin/deposits");
  const act = async (id, action) => {
    try { await api.post(`/admin/deposits/${id}/${action}`); toast.success(`Deposit ${action}d`); reload(); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="space-y-6">
      <PageTitle title="Deposits" subtitle="Review and approve member deposits" />
      <GlassCard className="p-6">
        {loading ? <div className="skeleton h-40" /> : data?.deposits?.length ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="text-left text-[var(--text-dim)]"><tr className="border-b border-white/10">
                <th className="py-3">ID</th><th className="py-3">Member</th><th className="py-3">Coin</th><th className="py-3">Amount</th><th className="py-3">Tx Hash</th><th className="py-3">Confs</th><th className="py-3">Status</th><th className="py-3">Actions</th></tr></thead>
              <tbody>
                {data.deposits.map((d) => (
                  <tr key={d.dep_id} className="row-hover border-b border-white/5" data-testid={`dep-row-${d.dep_id}`}>
                    <td className="py-3 text-white">{d.dep_id}</td><td className="py-3">{d.member_id}</td>
                    <td className="py-3">{d.coin}/{d.network}</td><td className="py-3 gold-text">${money(d.amount)}</td>
                    <td className="py-3"><BscScanLink hash={d.tx_hash} /></td>
                    <td className="py-3 text-[var(--text-dim)]">{d.verification?.confirmations != null && d.status !== "approved" ? `${d.verification.confirmations}${data?.required_confirmations ? ` / ${data.required_confirmations}` : ""}` : "—"}</td>
                    <td className="py-3">{(() => { const m = statusMeta(d.verification?.status || d.status); return <span className={`rounded-full border px-2.5 py-1 text-xs font-semibold ${m.cls}`}>{m.label}</span>; })()}</td>
                    <td className="py-3">
                      {d.status === "pending" && (
                        <div className="flex gap-2">
                          <LuxuryButton size="sm" onClick={() => act(d.dep_id, "approve")} data-testid={`dep-approve-${d.dep_id}`}>Approve</LuxuryButton>
                          <LuxuryButton size="sm" variant="dark" onClick={() => act(d.dep_id, "reject")} data-testid={`dep-reject-${d.dep_id}`}>Reject</LuxuryButton>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : <EmptyState icon={Wallet} title="No deposits" />}
      </GlassCard>
    </div>
  );
}
